import { defineComponent as d, openBlock as s, createElementBlock as o, normalizeClass as m, unref as u, createElementVNode as t, createTextVNode as r, toDisplayString as i, createCommentVNode as f } from "vue";
import { c as p } from "./cn-Bje3WtSp.js";
const b = { class: "flex-1" }, g = { key: 0 }, y = /* @__PURE__ */ d({
  __name: "ImpersonationBanner",
  props: {
    tenantName: {},
    sessionStartedAt: { default: void 0 },
    class: { default: void 0 }
  },
  emits: ["end-session"],
  setup(n) {
    const a = n;
    return (l, e) => (s(), o("div", {
      role: "alert",
      class: m(u(p)(
        "flex w-full items-center gap-3 border-b-2 border-warning bg-warning-muted px-4 py-2 text-sm text-text-primary",
        a.class
      ))
    }, [
      e[4] || (e[4] = t("span", {
        "aria-hidden": "true",
        class: "text-base"
      }, "⚠", -1)),
      t("div", b, [
        e[1] || (e[1] = t("strong", null, "Impersonation session active", -1)),
        e[2] || (e[2] = r(" — you are acting as ", -1)),
        t("strong", null, i(n.tenantName), 1),
        n.sessionStartedAt ? (s(), o("span", g, " since " + i(n.sessionStartedAt), 1)) : f("", !0),
        e[3] || (e[3] = r(". All actions are logged. ", -1))
      ]),
      t("button", {
        type: "button",
        class: "inline-flex h-8 items-center rounded-md border border-warning bg-surface-default px-3 text-sm font-medium text-text-primary hover:bg-surface-sunken focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
        onClick: e[0] || (e[0] = (x) => l.$emit("end-session"))
      }, " End session ")
    ], 2));
  }
});
export {
  y as _
};
//# sourceMappingURL=ImpersonationBanner.vue_vue_type_script_setup_true_lang-CMPfABo6.js.map
